import { urlsServices } from '@/config/urls';
import axios from 'axios';

let httpUrl = `${urlsServices.GETWAY}api/categoria-atendimento`;

export const getListCaegoriaAtendimento = async () => {
  return await axios.get(`${httpUrl}`).then((response) => response);
};

export const create = async (obj) => {
  return await axios.post(`${httpUrl}/create`, obj).then((response) => response);
};

export const getLista = async (filtros) => {
  return await axios.post(`${httpUrl}/listByFiltros`, filtros).then((response) => response);
};

export const getById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const deleteById = async (id) => {
  return await axios.delete(`${httpUrl}/${id}`).then((response) => response);
};
